import { render, staticRenderFns } from "./TencentCharityTips.vue?vue&type=template&id=488dd55e&scoped=true&"
import script from "./TencentCharityTips.vue?vue&type=script&lang=ts&"
export * from "./TencentCharityTips.vue?vue&type=script&lang=ts&"
import style0 from "./TencentCharityTips.vue?vue&type=style&index=0&id=488dd55e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488dd55e",
  null
  
)

export default component.exports